module.exports = __webpack_public_path__ + "media/images/conference-3-fa50279d4930b02e37b458f89626e739.jpg";